import { useEffect } from 'react';

import { recordView } from '../api';
import { config } from '../config';

/**
 * Records a single view for the given listing id once (per id change).
 * No-op when the listing id is missing or empavision is disabled.
 */
export const useViewRecorder = listingId => {
  useEffect(() => {
    if (!listingId || !config.isEnabled) {
      return;
    }

    recordView(listingId);
  }, [listingId]);
};
